import { render, staticRenderFns } from "./TrTestMultiCheckboxV2.vue?vue&type=template&id=769f5956&scoped=true&"
import script from "./TrTestMultiCheckboxV2.vue?vue&type=script&lang=js&"
export * from "./TrTestMultiCheckboxV2.vue?vue&type=script&lang=js&"
import style0 from "./TrTestMultiCheckboxV2.vue?vue&type=style&index=0&id=769f5956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f5956",
  null
  
)

export default component.exports